export const PROFILE_SAVE_ERRORS = Object.freeze({
  unavailable: 'Email verification is unavailable. No profile changes were saved.',
  rolledBack: 'Failed to initialize email verification for updated email. The email update was rolled back.',
  rollbackUnconfirmed: 'Failed to initialize email verification. Email rollback could not be confirmed. Contact support before retrying.',
  noPreviousEmail: 'Failed to initialize email verification for updated email. No previous email was available to restore. Contact support before retrying.',
});

export const PROFILE_SAVE_PARTIAL_WARNING = 'Other submitted profile changes may already have been saved.';
export const PROFILE_SAVE_UNKNOWN_ERROR = 'Unable to confirm the profile update. Refresh your profile before retrying. If the problem continues, contact support.';
const allowed = new Set<string>(Object.values(PROFILE_SAVE_ERRORS));

// Exact matches only: provider/SQL diagnostics can contain private values.
export function profileSaveErrorMessage(error: unknown): string {
  if (!(error instanceof Error) || !allowed.has(error.message)) return PROFILE_SAVE_UNKNOWN_ERROR;
  return error.message === PROFILE_SAVE_ERRORS.unavailable
    ? error.message
    : `${error.message} ${PROFILE_SAVE_PARTIAL_WARNING}`;
}
